import { useMutation } from '@tanstack/react-query';
import { Col, DatePicker, Form, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { DefaultOptionType } from 'antd/es/select';
import { PlantApi } from 'apis/PlantApis';
import { FormFilter, SelectForm } from 'components';
import { useUser } from 'contexts/UserProvider';
import dayjs from 'dayjs';
import Content from 'layouts/Content';
import { useEffect, useState } from 'react';

const spanCol = 12;

export interface FilterSaleLineEfficiencyProps {
  defaultFilter?: any;
  onFilter?: (values: any) => void;
  onCancel?: () => void;
}

const FilterSaleLineEfficiency = ({
  defaultFilter,
  onCancel,
  onFilter,
}: FilterSaleLineEfficiencyProps) => {
  const { user } = useUser();
  const [form] = useForm();
  const [plants, setPlants] = useState<DefaultOptionType[]>([]);

  const { mutate: getAllPlant, isPending: getAllPlantLoading } = useMutation({
    mutationFn: () => PlantApi.getAllPlantComboBox(),
    onSuccess: (data: any) => {
      const items = data.data?.getPlant?.items || [];

      if (!items?.length) return setPlants([]);

      setPlants(
        items.map((item: any) => ({
          label: item.id + (item.name ? ` - ${item.name}` : ''),
          value: item.id,
        })),
      );
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleChangePlant = (value: any) => {
    form.setFieldsValue({
      teamSalesId: undefined,
      routeId: undefined,
      plantId: value,
    });
  };

  const handleFinish = (values: any) => {
    onFilter?.(values);
  };

  const handleCancel = () => {
    form.resetFields();

    form.setFieldsValue({
      plantId: defaultFilter?.plantId,
      year: dayjs(),
    });

    onCancel?.();
  };

  useEffect(() => {
    getAllPlant();
  }, [getAllPlant]);

  useEffect(() => {
    if (defaultFilter) {
      form.setFieldsValue({
        plantId: defaultFilter.plantId,
        year: defaultFilter.year,
      });
    }
  }, [defaultFilter, form]);

  return (
    <Content isOpen>
      <FormFilter
        okTitle="Xem báo cáo"
        form={form}
        onFinish={handleFinish}
        onCancel={handleCancel}
      >
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item
              label="Chi nhánh"
              name="plantId"
              // rules={[{ required: true, message: 'Vui lòng chọn chi nhánh' }]}
            >
              <SelectForm
                loading={getAllPlantLoading}
                options={plants}
                placeholder="Chọn chi nhánh"
                disabled={user?.plantCode !== '5000'}
                onChange={handleChangePlant}
              />
            </Form.Item>
          </Col>

          <Col span={spanCol} className="h-[80px]">
            <Form.Item
              label="Thời gian xuất báo cáo"
              name="year"
              rules={[{ required: true, message: 'Vui lòng chọn thời gian' }]}
            >
              <DatePicker
                style={{
                  width: '100%',
                }}
                size="large"
                picker="month"
                maxDate={dayjs()}
                placeholder="Chọn thời gian"
                format="MM/YYYY"
                allowClear={false}
              />
            </Form.Item>
          </Col>
        </Row>
      </FormFilter>
    </Content>
  );
};

export default FilterSaleLineEfficiency;
